import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2075Status: 'idle',
    startProcess2075Error: undefined as any,
    loadUserParamsProcess2075Status: 'idle',
    loadUserParamsProcess2075Error: undefined as any,

    process2075List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2075 = createAsyncThunk('process2075Slice/startProcess2075', async ({ process2075 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2075/`,
        prepareData(process2075),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2075Status } = getState().process2075Slice
        return startProcess2075Status !== 'pending'
    }
})

export const loadUserParamsProcess2075 = createAsyncThunk('process2075Slice/loadUserParamsProcess2075', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2075/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2075Status } = getState().process2075Slice
        return loadUserParamsProcess2075Status !== 'pending'
    }
})

const Process2075Slice = createSlice({
    name: 'process2075Slice',
    initialState,
    reducers: {
        resetstartProcess2075: (state) => {
            state.job = undefined
            state.startProcess2075Error = undefined
        },
        resetstartProcess2075Error: (state) => {
            state.startProcess2075Error = undefined
        },
        resetloadUserParamsProcess2075: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2075Error = undefined
        },
        resetloadUserParamsProcess2075Error: (state) => {
            state.loadUserParamsProcess2075Error = undefined
        },
        removeFromProcess2075ListById: (state, action) => {
            state.process2075List = state.process2075List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2075ListByIds: (state, action) => {
            state.process2075List = state.process2075List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2075List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2075Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2075List = []
            state.startProcess2075Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2075.pending, (state) => {
            state.startProcess2075Status = 'pending'
            state.startProcess2075Error = undefined
        })
        builder.addCase(startProcess2075.fulfilled, (state, action) => {
            state.startProcess2075Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2075.rejected, (state, action) => {
            state.startProcess2075Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2075Error = action.error.message
            } else {
                state.startProcess2075Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2075.pending, (state) => {
            state.loadUserParamsProcess2075Status = 'pending'
            state.loadUserParamsProcess2075Error = undefined
        })
        builder.addCase(loadUserParamsProcess2075.fulfilled, (state, action) => {
            state.loadUserParamsProcess2075Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2075.rejected, (state, action) => {
            state.loadUserParamsProcess2075Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2075Error = action.error.message
            } else {
                state.loadUserParamsProcess2075Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2075,
    resetstartProcess2075Error,
    resetloadUserParamsProcess2075,
    resetloadUserParamsProcess2075Error,
    removeFromProcess2075ListById,
    removeFromProcess2075ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2075Slice.actions
export default Process2075Slice.reducer
